"use client";
import React, { useState, useEffect } from "react";
import { usePathname, useRouter } from "next/navigation";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@ui/dialog";
import { Button } from "@ui/button";
import { X } from "lucide-react";

const AdmissionPopup = () => {
  const pathname: string = usePathname();
  const router = useRouter();
  const excludedPaths: string[] = [
    "/auth/register",
    "/auth/login",
    "/dashboard",
    "/dashboard/admission-letter",
    "/landing/natural-medicine-pathway",
  ];
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const lastVisit = localStorage.getItem("lastVisit");
    const now = new Date().getTime();
    const halfDay = 12 * 60 * 60 * 1000;
    if (!lastVisit || now - Number(lastVisit) > halfDay) {
      const timer = setTimeout(() => {
        setIsOpen(true);
        localStorage.setItem("lastVisit", now.toString());
      }, 20000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleApplyNow = () => {
    router.push("/programmes");
    setIsOpen(false);
  };

  if (excludedPaths.includes(pathname)) {
    return null;
  }

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="max-w-md mx-auto bg-gradient-to-br from-healing-50 to-nature-50 border-2 border-healing-200">
        <button
          onClick={handleClose}
          className="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 z-10 cursor-pointer"
        >
          <X className="h-4 w-4" />
          <span className="sr-only">Close</span>
        </button>

        <DialogHeader className="text-center space-y-4 pt-2">
          <DialogTitle className="text-2xl font-bold text-gradient">
            Admission Now Open!
          </DialogTitle>
        </DialogHeader>

        <div className="text-center space-y-4 py-4">
          <p className="text-lg text-gray-700 leading-relaxed">
            Ready to begin your journey in Natural Medicine?
          </p>
          <p className="text-base font-semibold text-healing-700">
            Enroll for the March 2026 Intake today.
          </p>
          <p className="text-sm text-gray-600">
            Certificate, Diploma & Doctoral Programs Available
          </p>

          <Button
            onClick={handleApplyNow}
            className="w-full bg-healing-600 hover:bg-healing-700 text-white font-semibold py-3 text-lg animate-pulse cursor-pointer"
          >
            Apply Now
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AdmissionPopup;
